import { Client } from "creso-core/types";
import { CheckCircle2, Info, XCircle } from "lucide-react";

type KycSubject = Pick<Client, "name" | "kyc_status" | "kyc_status_remark">;

export function KycStatusBadge({
  kyc_status,
  remark,
}: {
  kyc_status?: string;
  remark?: string | null;
}) {
  if (kyc_status === "S") {
    if (remark === "KYC REGISTERED") {
      return (
        <div className="flex items-center gap-1.5 shrink-0 rounded-lg bg-muted px-3 py-2">
          <Info className="size-4 text-caution" />
          <span className="text-sm font-semibold">Registered</span>
        </div>
      );
    }
    return (
      <div className="flex items-center gap-1.5 shrink-0 rounded-lg bg-muted px-3 py-2">
        <CheckCircle2 className="size-4 text-constructive" />
        <span className="text-sm font-semibold">KYC Verified</span>
      </div>
    );
  }
  if (kyc_status === "F") {
    return (
      <div className="flex items-center gap-1.5 shrink-0 rounded-lg bg-muted px-3 py-2">
        <XCircle className="size-4 text-destructive" />
        <span className="text-sm font-semibold">Not Verified</span>
      </div>
    );
  }
  return null;
}

export function KycDescription({
  client,
  cachedName,
  actionHint = "once you click on create account",
}: {
  client: KycSubject | null;
  cachedName?: string | null;
  actionHint?: string;
}) {
  if (!client) return null;
  const firstName = client.name?.split(" ")[0] ?? "";

  if (client.kyc_status === "S") {
    if (cachedName) {
      return (
        <div className="rounded-lg p-3 border border-border text-xs text-muted-foreground">
          Updated &ldquo;{cachedName}&rdquo; with name found on PAN. Check PAN
          no. if there&apos;s a mismatch.
        </div>
      );
    }
    if (client.kyc_status_remark === "KYC REGISTERED") {
      return (
        <div className="rounded-lg p-3 border border-border text-xs">
          <span className="font-semibold">KYC Registered.</span>{" "}
          <span className="text-muted-foreground">
            Can transact with existing folios of AMCs for now. {firstName} can
            validate KYC or apply for re-KYC once they are active.
          </span>
        </div>
      );
    }
    return null;
  }

  if (client.kyc_status === "F") {
    return (
      <div className="rounded-lg p-3 border border-border text-xs">
        <span className="font-semibold">KYC Required.</span>{" "}
        <span className="text-muted-foreground">
          {firstName} will receive KYC link via SMS {actionHint}. They can also
          complete KYC from their app.
        </span>
      </div>
    );
  }

  return null;
}
